import script from "./EnableNotificationsCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnableNotificationsCTA.vue?vue&type=script&setup=true&lang=ts"

import "./EnableNotificationsCTA.vue?vue&type=style&index=0&id=62ea547e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ea547e"]])

export default __exports__